import Parse from "parse";

export const getOrderById = async (invoiceNo, warehouseCode) => {
    return Parse.Cloud.run("getOrderById", { invoiceNo, warehouseCode });
}

export const getOrdersFromPendingTable = (data) => {
    return Parse.Cloud.run("getOrdersFromPendingTable", data);
}